// extracted by mini-css-extract-plugin
module.exports = {"skeleton-loader":"__skeleton-loader__962cY","slideGradient":"__slideGradient__M376v"};